import axiosInstance from "@/services/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const instance = axiosInstance();
async function updatePaidPlan() {
  const response = await instance.get(`/customer/update-paid-plan`, {
    timeout: 10000,
  });
  return response.data;
}

export function useUpdatePlan() {
  return useQuery({
    queryFn: updatePaidPlan,
    queryKey: ["update-plan"],
    retry: 5,
  });
}
